import { useState } from 'react'
import { useParams } from 'react-router-dom'

function Login({ loginUser }) {
  const [user, setUser] = useState(null)
  const [password, setPassword] = useState(null)
  const params = useParams()
  const handleClick = () => {
    if(!user || !password) return alert('Por favor ingrese usuario y contraseña')
    fetch(`/api/user?cedula=${user}&password=${encodeURIComponent(password)}&token=${params.token}`)
      .then(response => response.json())
      .then(data => {
        console.log(data)
        loginUser(data)
      })
  }
  const handleChangeUser = (e) => {
    setUser(e.target.value)
  }
  const handleChangePassword = (e) => {
    setPassword(e.target.value)
  }
  return (
    <>
      <img src="/coop-logo.png" alt="" />
      <div className='div-login'>
        <p className='p-login'>Usuario</p>
        <input type="text" className='input-login' onChange={handleChangeUser}></input>
        <p className='p-login'>Contraseña</p>
        <input type="password" className='input-login'  onChange={handleChangePassword}></input>
        <br />
        <button onClick={handleClick} className='button-login'>Iniciar sesión</button>
      </div>
    </>
  )
}

export default Login
